import React from 'react'
import { InformationPopover } from './InformationPopover'
import { t } from '../../../i18n/i18n'
import TextOutput from '../inputs/TextOutput'
import { JSXElement, makeStyles, tokens } from '@fluentui/react-components'
import { ConsequenceAndProbabilityRisk } from '../../../api/schemas/schema'

const useStyles = makeStyles({
   bodyWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: tokens.spacingVerticalXL,
   },
})

type RiskscenarioPopoverProps = {
   risk: ConsequenceAndProbabilityRisk
   regularIcon: JSXElement
   filledIcon: JSXElement
}

export const RiskscenarioPopover = ({ risk, regularIcon, filledIcon }: RiskscenarioPopoverProps) => {
   const classes = useStyles()

   const body = () => {
      return (
         <div className={classes.bodyWrapper}>
            <TextOutput label={t('RiskScenario')} text={risk.scenario} />
            <TextOutput label={t('ConsequenceDescription')} text={risk.consequence} />
            <TextOutput label={t('RiskSource')} text={risk.source} />
            <TextOutput label={t('WeaknessesOrCurrentProtection')} text={risk.currentState} />
            <TextOutput label={t('UnderlyingMotivationAndStand')} text={risk.underlyingMotivation} />
         </div>
      )
   }

   return (
      <InformationPopover
         btnLabel={t('RiskScenario')}
         popoverLabel={t('Risk')}
         input={body()}
         regularIcon={regularIcon}
         filledIcon={filledIcon}
      />
   )
}
